import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box } from '@styleseat/ui';
import {
  GestureResponderEvent,
  ImageSourcePropType,
  Pressable,
} from 'react-native-web';

import Image from '../../Image';
import { BodyText } from '../../../ui';

export type SearchTileProps = {
  onPress?: () => void;
  source?: ImageSourcePropType;
  text?: string;
  imageHeight: number;
  imageWidth: number;
};

/**
 * Displays a clickable image with text beneath
 */
const SearchTile = ({
  onPress = () => {},
  source = null,
  text = '',
  imageHeight,
  imageWidth,
}: SearchTileProps) => {
  const handlePress = (event: GestureResponderEvent) => {
    // Prevent dialog from immediately being closed by click propagation
    event.preventDefault();
    event.stopPropagation();
    onPress();
  };
  const testID = `search-tile-${text.toLowerCase().replace(' ', '-')}`;

  return (
    <Pressable
      onPress={handlePress}
    >
      <Box
        flex={1}
        alignItems="center"
      >

        <Box
          style={{
            borderRadius: 4,
            flexGrow: 1,
          }}
          showBoxShadow
          minHeight={imageHeight}
          maxWidth={imageWidth}
          width="100%"
          testID={testID}
        >
          <Image
            source={source}
            style={{
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              width: '100%',
              height: imageHeight,
              objectFit: 'cover',
            }}
          />
          <Box
            height={30}
            style={{
              backgroundColor: BrandColor.WhiteWash,
              paddingVertical: 'auto',
            }}
            borderRadiusBottom={4}
          >
            <BodyText
              textAlign="center"
              appearance="medium"
              weight="bold"
              testID="search-tile-text"
              style={{ margin: 'auto' }}
            >
              {text}
            </BodyText>
          </Box>
        </Box>
      </Box>
    </Pressable>
  );
};

export default SearchTile;
